import { render, staticRenderFns } from "./LoginTip.vue?vue&type=template&id=1da90926&scoped=true"
import script from "./LoginTip.vue?vue&type=script&lang=js"
export * from "./LoginTip.vue?vue&type=script&lang=js"
import style0 from "./LoginTip.vue?vue&type=style&index=0&id=1da90926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da90926",
  null
  
)

export default component.exports